import { createReducer, on } from '@ngrx/store';
import { initialResetPasswordState } from './reset-password.constants';
import { ResetPasswordActions, ResetPasswordApiActions } from './reset-password.actions';

export const resetPasswordReducer = createReducer(
  initialResetPasswordState,

  on(ResetPasswordActions.enterPage, (_state, { token }) => ({
    ...initialResetPasswordState,
    resetToken: token,
    tokenStatus: token ? 'verifying' : 'idle',
    retry: token ? { type: 'verifyToken', token } : null,
  })),

  on(ResetPasswordActions.leavePage, () => initialResetPasswordState),
  on(ResetPasswordActions.startNewRequest, () => initialResetPasswordState),

  on(ResetPasswordActions.submitEmailRequest, (state, { email }) => ({
    ...state,
    loading: true,
    error: null,
    submittedEmail: email,
    retry: { type: 'requestEmail', email },
  })),
  on(ResetPasswordApiActions.requestEmailSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    step: 'check-email',
    retry: null,
  })),
  on(ResetPasswordApiActions.requestEmailFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ResetPasswordActions.resendEmail, (state) => ({
    ...state,
    loading: true,
    error: null,
    retry: { type: 'resendEmail', email: state.submittedEmail },
  })),
  on(ResetPasswordApiActions.resendEmailSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    step: 'check-email',
    resendAttempts: state.resendAttempts + 1,
    retry: null,
  })),
  on(ResetPasswordApiActions.resendEmailFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(ResetPasswordApiActions.verifyTokenSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    tokenStatus: 'valid',
    step: 'create-password',
    retry: null,
  })),
  on(ResetPasswordApiActions.verifyTokenFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: error === 'NETWORK' ? error : null,
    tokenStatus: error === 'NETWORK' ? 'idle' : 'invalid',
  })),

  on(ResetPasswordActions.submitNewPassword, (state, { newPassword }) => ({
    ...state,
    loading: true,
    error: null,
    retry: state.resetToken
      ? { type: 'updatePassword', token: state.resetToken, newPassword }
      : null,
  })),
  on(ResetPasswordApiActions.updatePasswordSuccess, (state) => ({
    ...state,
    loading: false,
    error: null,
    step: 'success',
    retry: null,
  })),
  on(ResetPasswordApiActions.updatePasswordFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
    tokenStatus: error === 'EXPIRED_TOKEN' ? 'invalid' : state.tokenStatus,
    retry: error === 'SAME_PASSWORD' ? null : state.retry,
    newPasswordCheck: error === 'SAME_PASSWORD' ? 'same' : state.newPasswordCheck,
  })),

  on(ResetPasswordActions.newPasswordChanged, (state) => ({
    ...state,
    newPasswordCheck: 'pending',
  })),
  on(ResetPasswordActions.newPasswordCheckReset, (state) => ({
    ...state,
    newPasswordCheck: 'idle',
  })),
  on(ResetPasswordApiActions.validateNewPasswordSuccess, (state, { matchesCurrent }) => ({
    ...state,
    newPasswordCheck: matchesCurrent ? 'same' : 'different',
  })),
  on(ResetPasswordApiActions.validateNewPasswordFailure, (state) => ({
    ...state,
    newPasswordCheck: 'different',
  })),

  on(ResetPasswordActions.resendCooldownStarted, (state, { seconds }) => ({
    ...state,
    resendRemainingSeconds: seconds,
  })),
  on(ResetPasswordActions.resendCooldownTick, (state, { remaining }) => ({
    ...state,
    resendRemainingSeconds: remaining,
  })),
  on(ResetPasswordActions.resendCooldownFinished, (state) => ({
    ...state,
    resendRemainingSeconds: 0,
  })),
);
